import React, { useContext, useEffect, useState } from "react";
import MyCarousel from "../../Components/Carousel/Carousel";
import { Link, useNavigate } from "react-router-dom";
import styles from "./FrontPage.module.css";


// Import images for the slider
import Box1 from '../../assets/HomePageImage/BoxLogoImage/Box1.png'
import Box2 from '../../assets/HomePageImage/BoxLogoImage/Box2.png'
import Box3 from '../../assets/HomePageImage/BoxLogoImage/Box3.png'
import Box4 from '../../assets/HomePageImage/BoxLogoImage/Box4.png'
import Box5 from '../../assets/HomePageImage/BoxLogoImage/Box5.png'
import Box6 from '../../assets/HomePageImage/BoxLogoImage/Box6.png'
import Box7 from '../../assets/HomePageImage/BoxLogoImage/Box7.png'
import Box8 from '../../assets/HomePageImage/BoxLogoImage/Box8.jpg'
import Box9 from '../../assets/HomePageImage/BoxLogoImage/Box9.png'
import Box10 from '../../assets/HomePageImage/BoxLogoImage/Box10.webp'


import Img1 from '../../assets/HomePageImage/NewIcons/Img1.png'
import Img2 from '../../assets/HomePageImage/NewIcons/Img2.png'
import Img3 from '../../assets/HomePageImage/NewIcons/Img3.png'
import Img4 from '../../assets/HomePageImage/NewIcons/Img4.png'
import Img5 from '../../assets/HomePageImage/NewIcons/Img5.png'
import Img6 from '../../assets/HomePageImage/NewIcons/Img6.png'
import Img7 from '../../assets/HomePageImage/NewIcons/Img7.png'
import Img8 from '../../assets/HomePageImage/NewIcons/Img8.png'
import Img9 from '../../assets/HomePageImage/NewIcons/Img9.png'

import votinglogo from '../../assets/HomePageImage/BoxLogoImage/votinglogo.png'
import CoinLogo from '../../assets/HomePageImage/BoxLogoImage/CoinLogo.png'
import AnimeLogo from '../../assets/HomePageImage/BoxLogoImage/AnimeLogo.png'
import SportLogo from '../../assets/HomePageImage/BoxLogoImage/SportLogo.png'
import Funlogo from '../../assets/HomePageImage/BoxLogoImage/Funlogo.png'
import StockLogo from '../../assets/HomePageImage/BoxLogoImage/StockLogo.png'
import TheVoteLogo from '../../assets/HomePageImage/BoxLogoImage/TheVoteLogo.png'
import PokerLogo from '../../assets/HomePageImage/BoxLogoImage/PokerLogo.png'


import SportView from '../../assets/HomePageImage/SportView.png';
import PlayView from '../../assets/HomePageImage/PlayView.png';
import MoneyView from '../../assets/HomePageImage/MoneyView.png';
import TopSilder from "./TopSilder";
import ShowAllApp from "./ShowAllApp";
import axios from "axios";
import { auth } from "../../firebase";
import UserContext from "Contexts/User";


const parliamentShowcaseDatasec = [
  {
    id: 1,
    slogan: "Join the Community",
    description: "Vote to Earn isn’t just about playing it’s about belonging. Join Parliaments, connect with other players, and grow your influence. Whether you’re here for fun, competition, or rewards, there’s a place for everyone.",
    buttonText: "Coming Soon",
    image: Box9,
    imageAlt: "Voting Parliament - Pizza vs Hamburger",
    link: ""
  },
  {
    id: 2,
    slogan: "Charity",
    description: "Giving back is at the heart of Vote To Earn. For every PAX token minted, members can choose to support one of the following charitable foundations: UNICEF, Save the Children, Salvation Army, United Way, American Red Cross Select your preferred charity, and we'll donate an extra 10%.",
    image: Box10,
    imageAlt: "Coin Parliament - Dogecoin vs Shiba Inu",
    link: ""
  },

];

enum SiteTypes {
  coin = "coin",
  sport = "sport",
  stock = "stock",
  voting = "voting",
  fun = "fun",
  poker = "poker",
  anime = "anime",
}

const FrontPage: React.FC = () => {
  const [sites, setSites] = useState<{ [key: string]: any }>({
    [SiteTypes.coin]: {
      redirect: "https://coinparliament.com/",
      domain: process.env.REACT_APP_COIN_API,
      name: "coin",
      isLive: true
    },
    [SiteTypes.sport]: {

      redirect: "https://sportparliament.com/",
      domain: process.env.REACT_APP_SPORT_API,
      name: "sport",
      isLive: true
    },
    [SiteTypes.stock]: {
      redirect: "https://stockparliament.com/",
      domain: process.env.REACT_APP_STOCK_API,
      name: "stock",
      isLive: true
    },
    [SiteTypes.voting]: {

      redirect: "https://votingparliament.com/",
      domain: process.env.REACT_APP_VOTING_API,
      name: "voting",
      isLive: true
    },
    [SiteTypes.fun]: {
      redirect: "https://funparliament.com/",
      domain: process.env.REACT_APP_FUN_API,
      name: "fun",
      isLive: true
    },
    [SiteTypes.poker]: {
      redirect: "https://pokerparliament.com/",
      domain: process.env.REACT_APP_POKER_API,
      name: "poker",
      isLive: true
    },
    [SiteTypes.anime]: {
      redirect: "https://animevoting.com/",
      domain: process.env.REACT_APP_ANIME_API,
      name: "anime",
      isLive: true
    },
  });
  const [oneKeyActive, setOneKeyActive] = useState(false);
  const { user, userInfo } = useContext(UserContext);
  const navigate = useNavigate();
  const [userIds, setUserIds] = useState(() => {
    try {
      const storedUserId = localStorage.getItem("userId");
      if (!storedUserId) return {};

      const parsed = JSON.parse(storedUserId);
      // Check if parsed value is an object and not null or array
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        return parsed;
      }
      return {};
    } catch (error) {
      console.error("Error parsing userId from localStorage:", error);
      return {};
    }
  });

  const [EmailId, setEmailId] = useState(() => localStorage.getItem("EmailId") || "");

  const parliamentShowcaseData = [
    {
      id: 1,
      title: "Coin Parliament",
      icon: CoinLogo,
      iconClass: "coinIcon",
      slogan: "Feel the Market. Vote the Moment.",
      description: "Crypto meets vibes.",
      examples: [
        "No wallets needed, just your gut.",
        "Bitcoin to the moon or meme coin takeover?"
      ],
      benefit: "Fresh picks drop daily built by creators, boosted by AI.",
      buttonText: "Join now",
      image: Box2,
      imageAlt: "Coin Parliament - Dogecoin vs Shiba Inu",
      link: sites["coin"].redirect,
    },
    {
      id: 2,
      title: "Voting Parliament",
      icon: votinglogo,
      iconClass: "votingIcon",
      slogan: "Anything vs. Anything.",
      description: "Vote on anything, anytime from bold opinions to bizarre battles.",
      examples: [
        "Netflix binge vs. YouTube spiral",
        "Tattoos or piercings?"
      ],
      benefit: "This is where creators and AI keep it spicy you just tap and earn.",
      buttonText: "Coming Soon",
      image: Box1,
      imageAlt: "Voting Parliament - Pizza vs Hamburger",
      link: sites["voting"].redirect
    },
    {
      id: 3,
      title: "Sport Parliament",
      icon: SportLogo,
      iconClass: "coinIcon",
      slogan: "For Fans Who Want More.",
      description: "Every match is a moment. Call the shots on live games, plays, and GOAT debates.",
      examples: [
        "Goal-line save or buzzer beater?",
        "Messi vs. Ronaldo (again)?",
      ],
      benefit: "AI keeps it current. Creators keep it 🔥. You get the final say.",
      buttonText: "Coming Soon",
      image: Box3,
      imageAlt: "Sport Parliament",
      link: sites["sport"].redirect
    },
    {
      id: 4,
      title: "Anime Voting アニメ投票",
      icon: AnimeLogo,
      iconClass: "coinIcon",
      slogan: "Your Fandom, Your Vote. あなたの推しに、あなたの票を。",
      description: "Battle it out with original anime-inspired characters in daily matchups. Vote, climb the leaderboard, and earn real rewards all in one epic arena.",
      examples: [
        "オリジナルのアニメ風キャラたちが毎日バトル！",
        "投票して、ランキングを駆け上がり、リアルな報酬をゲットしよう。",
        "すべてがここにある、あなたのためのアリーナ。",
      ],
      benefit: "",
      buttonText: "Coming Soon",
      image: Box4,
      imageAlt: "Anime Voting アニメ投票",
      link: sites["anime"].redirect
    },
    {
      id: 5,
      title: "Stock Parliament",
      icon: StockLogo,
      iconClass: "StockIcon",
      slogan: "Markets Just Got Fun",
      description: "Wall Street drama, TikTok speed.",
      examples: [
        "Apple vs. Tesla",
        "Recession coming or nah?",
        "You vote. You earn.",
      ],
      benefit: "The smartest takes aren’t on CNBC they’re in here.",
      buttonText: "Coming Soon",
      image: Box5,
      imageAlt: "Anime Voting アニメ投票",
      link: sites["stock"].redirect
    },
    {
      id: 6,
      title: "The Vote",
      icon: TheVoteLogo,
      iconClass: "coinIcon",
      slogan: "Real Opinions. Real Change.",
      description: "The serious side of Vote to Earn.",
      examples: [
        "For media, brands, and communities that want real-time feedback without fluff.",
      ],
      benefit: "Built for decisions, not distractions.",
      buttonText: "Coming Soon",
      image: Box6,
      imageAlt: "The Vote",
      link: ""
    },
    {
      id: 7,
      title: "Fun Parliament",
      icon: Funlogo,
      iconClass: "coinIcon",
      slogan: "Meme Worthy. Matchups. Daily.",
      description: "Pure chaos, zero pressure.",
      examples: [
        "Stay in or go out?",
        "Pizza vs. sushi. Sleep in vs. sunrise.",
        "Polls made by your crew (and a little AI magic)."

      ],
      benefit: "Tap in. Be loud. Win stuff.",
      buttonText: "Coming Soon",
      image: Box7,
      imageAlt: "Fun Parliament",
      link: sites["fun"].redirect
    },
    {
      id: 8,
      title: "Poker Parliament",
      icon: PokerLogo,
      iconClass: "coinIcon",
      slogan: "What's the Move?",
      description: "Your hand. Their move.",
      examples: [
        "You're the table.",
        "Flop hits. Opponent raises. You got pocket 10s.",
        "What’s your move?"
      ],
      benefit: "Fold. Call. Raise. Let the community decide.",
      buttonText: "Coming Soon",
      image: Box8,
      imageAlt: "Poker Parliament",
      link: sites["poker"].redirect
    }


  ];


  useEffect(() => {
    const handleStorageChange = (e: any) => {
      if (e.key === "userId") {
        setUserIds(e.newValue);
      }
      if (e.key === "EmailId") {
        setEmailId(e.newValue);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  const [loading, setLoading] = useState("");
  const redirectUserToSite = (site: { [key: string]: string }) => {
    setLoading(site.name);
    axios
      .post(`${site.domain}isLoggedInFromVoteToEarn`, {
        data: {
          userId: userIds[site.name],
          email: EmailId || auth.currentUser?.email,
        },
      })
      .then((response) => {
        if (response?.data?.result?.token) {
          setSites((prev) => {
            return {
              ...prev,
              [site.name]: {
                ...site,
                redirect: `${site.redirect}?token=${response?.data?.result?.token}`,
              },
            };
          });
        }
      })
      .catch((err) => {
        console.log(err)
      }).finally(() => {
        setLoading("");
      })
  };
  useEffect(() => {
    if (Object.keys(userIds).length < 1) return;
    redirectUserToSite(sites.coin);
    redirectUserToSite(sites.sport);
    redirectUserToSite(sites.stock);
    redirectUserToSite(sites.voting);
  }, [auth.currentUser?.email]);

  useEffect(() => {
    const oneKey = localStorage.getItem("oneKey")
    setOneKeyActive(oneKey === "true" ? true : false)
  }, [oneKeyActive])

  const handalOneKey = () => {
    localStorage.setItem("oneKey", "true")
    setOneKeyActive(true)
    if (!user) {
      navigate("/onekey")
    } else if (user?.uid) {
      navigate("/apps")
    }
  }

  const iconsForGrid = [
    { src: Img1, name: 'COIN PARLIAMENT', link: sites["coin"].redirect },
    { src: Img2, name: 'VOTING PARLIAMENT', link: sites["voting"].redirect },
    { src: Img3, name: 'STOCK PARLIAMENT', link: sites["stock"].redirect },
    { src: Img6, name: 'THE VOTE', link: "" },
    { src: Img9, name: 'One Key', link: "abc" }, // Center button
    { src: Img7, name: 'ANIME VOTING', link: sites["anime"].redirect },
    { src: Img5, name: 'POKER PARLIAMENT', link: sites["poker"].redirect },
    { src: Img4, name: 'FUN PARLIAMENT', link: sites["fun"].redirect },
    { src: Img8, name: 'SPORT PARLIAMENT', link: sites["sport"].redirect },
  ];

  return (
    <div className={styles.frontPageContainer}>


      {/* Header Section */}
      <div className={styles.newHeroSection}>
        <h1 className={styles.newHeroTitle}>
          <span className={styles.voteText}>Vote</span>
          <span className={styles.toText}>to</span>
          <span className={styles.earnText}>Earn</span>
        </h1>
        <p className={styles.newHeroSubtitle}>Scroll. Vote. Earn. Repeat.</p>
      </div>

      {/* Icons Grid */}
      <div className={styles.newIconsGridContainer}
      >
        <div className={styles.newIconsGrid}>
          {iconsForGrid.map((item, idx) => {
            const isDisabled = !item.link || item.link === "";
            const isOneKey = idx === 4;

            return (
              <div key={idx} className={styles.newIconCard}>
                <div
                  className={`${styles.newIconImageWrapper} ${isDisabled && !isOneKey ? styles.disabled : ''}`}
                  onClick={() => {
                    // if (isOneKey) {
                    //   handalOneKey();
                    // } else if (item?.link && item.link !== "") {
                    //   window.open(item.link, '_blank');
                    // }
                    handalOneKey();
                  }}
                  style={{ cursor: isDisabled && !isOneKey ? 'not-allowed' : 'pointer' }}
                >
                  <img src={item.src!} alt={item.name} className={styles.newIconImage} />
                </div>
                <span className={styles.newIconName}>{item.name}</span>
              </div>
            );
          })}
        </div>
      </div>

      {/* <div className={styles.headerSection}>
        <h1 className={styles.headerTitle}>MORE <span style={{color: '#fff'}}>THAN</span> A GAME.</h1>                            
        <TopSilder />
        <button className={styles.ctaButton} onClick={handalOneKey}>Start Voting</button>
        <div className={styles.subtitle}>You <span className={styles.goldenText}>Vote</span>. You <span className={styles.goldenText}>Earn</span>. It's That <span className={styles.goldenText}>Simple</span>.</div>
        <div className={styles.subtitle}>
          Everyone brings the content, AI runs the game, and you get rewarded for every move.
        </div>
      </div>    */}
      {/* Parliament Showcase */}
      {/* <ShowAllApp parliamentShowcaseData={parliamentShowcaseData} />    */}

      {/* How it works */}
      {/* <div className={styles.howItWorksSection}>
        <h2>HOW IT WORKS</h2>
        <div className={styles.stepsContainer}>
          <div className={styles.stepCard}>
            <div className={styles.stepCircle}>
              <h3>Choose</h3>
              <p>Pick a topic you love and start voting in fun matchups from celebs to crypto, sports, anime, and more.</p>
            </div>
          </div>
          <div className={styles.stepCard}>
            <div className={styles.stepCircle}>
              <h3>Play</h3>
            <p>Swipe, vote, and grow your Parliament. Every move brings you closer to rewards.</p>
            </div>
          </div>
          <div className={styles.stepCard}>
            <div className={styles.stepCircle}>
              <h3>Earn</h3>
            <p>Your CMP (Coin Mining Points) fills with every vote. Hit 100, and you unlock real digital rewards sent straight to your wallet.</p>
            </div>
          </div>
        </div>
        <div className={styles.howItWorksConclusion}>
          <p>Every vote isn't just a choice it's a chance to earn. Unlock unique collectibles, digital assets, and token rewards with real value. Trade and grow your collection while playing social, skill based games that keep it fun and fair for everyone.</p>
          <div className={styles.rewardImagesContainer}>
            <img src={SportView} alt="Sport View" className={styles.rewardImage} />
            <img src={PlayView} alt="Play View" className={styles.rewardImage} />
            <img src={MoneyView} alt="Money View" className={styles.rewardImage} />
          </div>
        </div>

      </div> */}

      {/* <ShowAllApp parliamentShowcaseData={parliamentShowcaseDatasec} />   */}
      {/* <div className={styles.footer}>
        <div className={styles.footerContent}>
          <div className={styles.footerColumns}>
            <div className={styles.footerColumn}>
              <h4>Explore</h4>
              <ul>
                <li><Link to="/apps">Apps</Link></li>
                <li><Link to="/buyget">BUY & GET</Link></li>
                <li><Link to="/profile/walletDetails">Vcoin & V Back</Link></li>
              </ul>
            </div>
            
            <div className={styles.footerColumn}>
              <h4>Contact</h4>
              <ul>
                <li><Link to="/profile/contactus">Contact us</Link></li>
                <li><a href="https://telegram.me/VoteToEarnChat" target="_black">Community</a></li>
              </ul>
            </div>
            
            <div className={styles.footerColumn}>
              <h4>Social</h4>
              <ul>
                <li><a href="https://www.votetoearn.net/thenewsocial" target="_black">The new social</a></li>
                <li><a href="https://www.votetoearn.net/thenewsocial" target="_black">Partner With Us</a></li>
                <li><a href="https://www.votetoearn.net/thenewsocial" target="_black">Tag Us on Social</a></li>
                <li><a href="https://www.votetoearn.net/thenewsocial" target="_black">Creator Program</a></li>
              </ul>
            </div>
            
            <div className={styles.footerColumn}>
              <h4>Legal</h4>
              <ul>
                <li><a href="https://www.votetoearn.net/terms-and-conditions" target="_black">Terms & Conditions</a></li>
                <li><a href="https://www.votetoearn.net/privacy-policy" target="_black">Privacy Policy</a></li>
                <li><a href="https://www.votetoearn.net/cookies-notice" target="_black">Cookies Notice</a></li>
                <li><a href="https://www.votetoearn.net/disclaimer" target="_black">Disclaimer</a></li>
              </ul>
            </div>
          </div>
          
          <div className={styles.socialIcons}>
            <a href="https://www.instagram.com/votetoearn" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            <a href="https://www.facebook.com/VoteToEarn/" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
              </svg>
            </a>
            <a href="https://x.com/VoteToEarn" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
              </svg>
            </a>
            <a href="https://www.tiktok.com/@votetoearn" target="_blank" rel="noopener noreferrer" className={styles.socialIcon}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
              </svg>
            </a>
          </div>
          
          <div className={styles.copyright}>
            <p>© 2025 Vote To Earn. All rights reserved.</p>
            <p>Built for the community. Powered by creativity</p>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default FrontPage; 
